import { FC } from "react";
import Tab from "@mui/material/Tab";
import CloseIcon from "@mui/icons-material/Close";
import { StyledTabs } from "./styled";

const EmployeesTabs: FC<{
  tab: number;
  setTab: (value: React.SetStateAction<number>) => void;
  selectedEmployees: {
    birthdate: string;
    id: number;
    name: string;
    patronimyc: string;
    phoneNumber: string;
    surname: string;
  }[];
  setSelectedEmployees: (
    value: React.SetStateAction<
      {
        birthdate: string;
        id: number;
        name: string;
        patronimyc: string;
        phoneNumber: string;
        surname: string;
      }[]
    >
  ) => void;
}> = ({ tab, setTab, selectedEmployees, setSelectedEmployees }) => {
  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const handleCloseTab = (id: number) => {
    const elemIndex = selectedEmployees.findIndex((elem) => elem.id === id);

    const employeesWithoutRemoved = [
      ...selectedEmployees.slice(0, elemIndex),
      ...selectedEmployees.slice(elemIndex + 1),
    ];

    if (tab === 0) {
      setTab(0);
    } else if (employeesWithoutRemoved.length < tab) {
      setTab(employeesWithoutRemoved.length);
    }

    setSelectedEmployees(employeesWithoutRemoved);
  };

  return (
    <StyledTabs
      value={tab}
      onChange={handleChangeTab}
      variant="scrollable"
      scrollButtons="auto"
      aria-label="scrollable auto tabs example"
    >
      <Tab label="Реестр" />
      {selectedEmployees.map((employee) => (
        <Tab
          key={employee.id}
          label={employee.name + " " + employee.surname}
          icon={
            <CloseIcon
              onClick={(event) => {
                handleCloseTab(employee.id);
                event.stopPropagation();
              }}
            />
          }
          iconPosition="end"
        />
      ))}
    </StyledTabs>
  );
};

export default EmployeesTabs;
